import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../db/indexedDb';

export function useTracks() {
  return useLiveQuery(() => db.tracks.orderBy('title').toArray(), [], []);
}

export function useTrack(trackId?: string) {
  return useLiveQuery(() => (trackId ? db.tracks.get(trackId) : undefined), [trackId]);
}

export function usePlaylists() {
  return useLiveQuery(() => db.playlists.orderBy('updatedAt').reverse().toArray(), [], []);
}

export function usePlaylist(playlistId?: string) {
  return useLiveQuery(() => (playlistId ? db.playlists.get(playlistId) : undefined), [playlistId]);
}

export function useSettings() {
  return useLiveQuery(() => db.getAppSettings(), [], undefined);
}
